import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { externalHealthDashboardAccessControl } from '../access-control/externalHealthDashboardAccess.configuration'
const PartnerStatusPage = lazy(() => import('../pages/partner-status/PartnerStatusPage'))
// @hygen:inject page-import
// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const externalHealthDashboardRouter = (
  <DomainRoute
    route="external-health-dashboard-partner-status"
    accessControl={externalHealthDashboardAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="external-health-dashboard-partner-status"
        component={PartnerStatusPage}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
